<ng-container *ngIf="(notifications$ | async) as notifications">
  <div class="btn-alertes" *ngIf="!hideIfNoAlerte || (notifications && notifications.hasDisplayableNotification)" (click)="showNotifications(notifications)">
    <i class="material-icons">notifications_none</i>
    <span class="badge-alertes" *ngIf="notifications.countUnread">{{ notifications.countUnread }}</span>
  </div>
</ng-container>
